import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { cssTransition } from 'react-toastify';
import { Toaster } from './Toaster';
import 'react-toastify/dist/ReactToastify.css';
import { Crumb } from './Crumb';
var ToastPosition;

(function (ToastPosition) {
  ToastPosition["topCenter"] = "top-center";
  ToastPosition["bottomCenter"] = "bottom-center";
})(ToastPosition || (ToastPosition = {}));

var handleUpdateToast = function handleUpdateToast(_ref) {
  var handleUpdate = _ref.handleUpdate,
      title = _ref.title,
      body = _ref.body,
      customIcon = _ref.customIcon,
      link = _ref.link,
      linkText = _ref.linkText;
  handleUpdate === null || handleUpdate === void 0 ? void 0 : handleUpdate();
  toast( /*#__PURE__*/React.createElement(Crumb, {
    icon: customIcon,
    title: title,
    body: body,
    link: link,
    linkText: linkText
  }), {
    pauseOnHover: false,
    draggable: false
  });
};

var ToastNotification = function ToastNotification(_ref2) {
  var position = _ref2.position,
      _ref2$hasCloseButton = _ref2.hasCloseButton,
      hasCloseButton = _ref2$hasCloseButton === void 0 ? false : _ref2$hasCloseButton,
      _ref2$shouldDismiss = _ref2.shouldDismiss,
      shouldDismiss = _ref2$shouldDismiss === void 0 ? true : _ref2$shouldDismiss,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? 'toast-container' : _ref2$className;
  var toastTransitions = position === ToastPosition.topCenter ? cssTransition({
    enter: 'bounce-in-top',
    exit: 'slide-out-top'
  }) : cssTransition({
    enter: 'bounce-in-bottom',
    exit: 'slide-out-bottom'
  });
  return /*#__PURE__*/React.createElement(Toaster, null, /*#__PURE__*/React.createElement(ToastContainer, {
    className: className,
    position: position,
    autoClose: shouldDismiss && 5000,
    closeButton: hasCloseButton,
    hideProgressBar: true,
    transition: toastTransitions,
    closeOnClick: false
  }));
};

export { ToastNotification, handleUpdateToast, ToastPosition };